import {DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule, DatePipe, registerLocaleData} from '@angular/common';
import {AppStoreModule} from '~ngrx/app-store.module';
import {JwtModule} from '@auth0/angular-jwt';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {HttpConsoleInterceptor} from './inteceptors/http-console.interceptor';
import {ProxyInterceptor} from './inteceptors/proxy.interceptor';
import localeBr from '@angular/common/locales/pt';
import localeBrExtra from '@angular/common/locales/extra/pt';
import {ServiceWorkerModule} from '@angular/service-worker';
import {AbstractMqttService} from '~core/api/mqtt/abstract-mqtt.service';
import {MqttFactory} from '~core/api/mqtt/MqttFactory';
import {Store} from '@ngrx/store';
import {MqttModule} from 'ngx-mqtt';
import { mqttConfig } from './config/mqtt-config';
import { environment } from '~env/environment';

const {adds, production, disableWorker} = environment; // Remover ou ajustar conforme uso real
registerLocaleData(localeBr, adds.defaultLanguage, localeBrExtra);

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AppStoreModule,
    //! HttpClientModule removed as it's deprecated
    MqttModule.forRoot(mqttConfig),
    JwtModule.forRoot({
      config: {
        tokenGetter: req => ProxyInterceptor.getToken(req),
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: production && !disableWorker}),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {provide: HTTP_INTERCEPTORS, useClass: ProxyInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpConsoleInterceptor, multi: true},
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL'},
    {provide: LOCALE_ID, useValue: adds.defaultLanguage},
    {provide: AbstractMqttService, useFactory: MqttFactory, deps: [Store]},
    DatePipe,
  ],
})
export class CoreModule {
}
